





import Vue from 'vue';
import baseMenu from './BaseMenu.vue';

export default Vue.extend({
    components: { baseMenu },
    data: () => {
        return {
            links: [
                {
                    icon: 'mdi-monitor-dashboard',
                    label: 'labels.dashboard',
                    href: '/',
                },
                {
                    icon: 'mdi-format-list-bulleted',
                    label: 'labels.prestazioni',
                    href: '/prestazioni',
                },
            ],
        };
    },
});
